import { Alert } from '@mui/material'
import { getStore } from '../../Store'
const store = getStore();

export function HandleAuthError() {
    store.updateToken(null)
    store.updateUser(null)
    store.updatePassword(null)
}

export function GenericStackTraceValidator(stackTrace, objectName) {
    if (stackTrace.toLowerCase().includes('data too long for column')) {
        const regex = /(Data too long for column )'[^']*'+/g;
        return stackTrace.match(regex)[0];
    }
    if (stackTrace.toLowerCase().includes('user request limit reached')) {
        return "Facebook API Limit Reached!";
    }
    if (stackTrace.toLowerCase().includes('token is expired')) {
        return "FB API Token Expired!"
    }
    if (stackTrace.toLowerCase().includes('duplicate entry')) {
        return "Duplicate entry for " + objectName
    }
    if (stackTrace.toLowerCase().includes('keyerror')) {
        return "Missing required field for " + objectName
    }
    if (stackTrace.toLowerCase().includes('add a valid payment method to your ad account')) {
        return "Payment method missing"
    }
    return null
}

export const SuccessAlert = ({ message }) => {
    return <Alert severity="success" style={{ backgroundColor: 'green', color: 'white', position: 'fixed', bottom: '20px', width: '90%', margin: 'auto', zIndex: 10000, left: 0, right: 0 }}>{message}</Alert>
}
export const StatusAlert = ({ message }) => {
    return <Alert severity="info" style={{ backgroundColor: 'grey', color: 'white', position: 'fixed', bottom: '20px', width: '90%', margin: 'auto', zIndex: 10000, left: 0, right: 0 }}>{message}</Alert>
}
export const ErrorAlert = ({message}) => {
    return  <Alert severity="error" style={{backgroundColor: 'red', color: 'white', position: 'fixed', bottom: '20px', width: '90%', margin: 'auto', zIndex: 10000, left: 0, right: 0}}>{message}</Alert>
}